import * as React from 'react';
import { ContentfulFrame, ContentfulHeroFrame } from '../../interfaces';
import './frame-page-display.scss';
import { FRAMES } from './frame-page-display-properties';

export interface FramePageDisplayProperties {
  isHomePage: boolean;
  frames: Array<ContentfulFrame | ContentfulHeroFrame>;
  theme?: string;
  isDarkTheme: boolean;
}

export const FramePageDisplay = ({ isHomePage, frames }: FramePageDisplayProperties) => (
  <div className={`frames ${isHomePage ? 'homepage' : ''}`}>
    {frames &&
      frames.map((frame, index) => {
        switch (frame.__typename) {
          case 'ContentfulHeroFrame': {
            const { Component, mapProps } = FRAMES[frame.__typename];
            return <Component key={index} {...mapProps(frame, {})} />;
          }
          case 'ContentfulFrame': {
            const { Component, mapProps } = FRAMES[frame.__typename];
            return (
              <Component
                key={index}
                {...mapProps(frame, {
                  frame,
                  index,
                  isLastFrame: index === frames.length - 1,
                  useDarkTheme: index === 0,
                  showScrollIndicator: isHomePage && index === 0,
                  hasUnsetWidth: frame.hasUnsetWidth || false,
                })}
              />
            );
          }
          default:
            return null;
        }
      })}
  </div>
);
